import React from 'react'
import styled from 'styled-components';
import { Header, Message, Icon } from 'semantic-ui-react'
import loadable from "@loadable/component";


import { __ } from '~/i18n'

import { CheckoutButtons } from '~/components/checkout'
import ComponentLoader from '~/components/component-loader';


import logic from './logic'

import Form from './contact-form'
import { LoggedIn } from '~/components/auth'

const Account = loadable(() => import(/* webpackChunkName: "account" */ './account'), {fallback: <ComponentLoader />});

const ContactStepContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  
  .sub.header {
    margin-bottom: 10px;
  }
`;

const ButtonsContainer = styled.div`
  flex-shrink: 0;
  margin-top: auto;
`;

const LoggedInContainer = styled.div`
  margin: 20px 0 30px;
`;

@logic
export default class ContactStep extends React.PureComponent {
  handleContinue = () => {
    const { submit } = this.props.actions;

    submit();
  };
  render() {
    const {
      showContactForm,
      showLogin,
      loginRequired,
      guestAllowed,
      onBack,
      loading,
      loggedIn,
      shippingRequired
    } = this.props;
    let accountContainer, formContainer;

    if(showLogin) {
      accountContainer = <Account description={ loginRequired ? __('To continue you must log in or create an account') : __('Create an account') } />
    }

    if(showContactForm) {
      formContainer = (
        <div>
          { guestAllowed ? <Header>{ __("Or continue as guest") }</Header> : null }
          <Form />
        </div>
      )
    }

    return (
      <ContactStepContainer>
        <Header size='large'>{ __("Customer Information") }</Header>
        <Header.Subheader>
          { shippingRequired ? __("Provide the details of the person who makes the transaction here. Shipping address comes in the next step.") : __("Provide the details of the person who makes the transaction here.") }
        </Header.Subheader>
        { loggedIn ? <LoggedInContainer>
          <Message positive icon>
            <Icon name='user outline' />
            <Message.Content>
              <LoggedIn />
            </Message.Content>
          </Message>
        </LoggedInContainer>: null }
        { accountContainer }
        { formContainer }
        <ButtonsContainer>
          <CheckoutButtons
            onBack={ onBack }
            onContinue={ this.handleContinue }
            loading={ loading }
            continueDisabled={ loginRequired && !loggedIn }
          />
        </ButtonsContainer>
      </ContactStepContainer>
    )
  }
}
